"use strict";

import React from 'react';
import FormSelectState from "../../component/FormSelectState";
import Cleave from "cleave.js/react";
import {Controller} from "react-hook-form";
import validation from "../../validation";
import FormAddressInputAutoSuggest from "../../component/FormAddressInputAutoSuggest";
import AccountAddressFormPhoneInput from "./AccountAddressFormPhoneInput";

const AccountAddressFormInput = ({
    errors={},
    register=()=>{},
    control={},
    setValue=()=>{},
    autoFocusFirstName=true,
    showAddressName=false,
    showAddressLocationType=true,
    type='billing',
    getInputClassName=()=>{},
    autoSuggestAddress=true,
    autoSuggestInputName='data_input_field_1',
    onSuggestedAddressSelect=()=>{},
}) => {
    const addressValidationRules = {
        required: true,
        validate: {
            isPoBox: (value)=>{
                if(type === 'shipping')
                    return !validation.isPoBox(value);
                else
                    return true;
            },
        },
    };

    return (
        <fieldset className="account__form__fieldset">
            { !showAddressName && <input type="hidden" {...register('address_name')} /> }
            <ol className="form__input-list account__form__list">
                { showAddressName &&
                <li className="form__input-list-item">
                    <label htmlFor="account-form--address-name"
                           className="label__required">
                        Address Name
                    </label>
                    <input type="text"
                           {...register('address_name',{required: true})}
                           id="account-form--address-name"
                           autoFocus={autoFocusFirstName}
                           maxLength="25"
                           className={getInputClassName('address_name')}/>
                    {!!errors.address_name &&
                    <small className="form__error">
                        An address name is required
                    </small>
                    }
                </li>
                }

                <li className="form__input-list-item">
                        <label htmlFor="account-form--first-name"
                               className="form__label form__label--required">
                            First Name:
                        </label>
                        <input type="text"
                               {...register('f_name',{required: true})}
                               id="account-form--first-name"
                               autoFocus={ (autoFocusFirstName && !showAddressName) }
                               maxLength="25"
                               className={getInputClassName('f_name')}/>
                    {!!errors.f_name &&
                        <small className="form__error">
                            First name is required
                        </small>
                    }
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--last-name"
                           className="form__label form__label--required">
                        Last Name:
                    </label>
                    <input type="text"
                           {...register('l_name',{required: true})}
                           id="account-form--last-name"
                           maxLength="35"
                           className={getInputClassName('l_name')}/>
                    {!!errors.l_name &&
                        <small className="form__error">
                            Last name is required
                        </small>
                    }
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--company-name">Company:</label>
                    <input type="text"
                           {...register('company_name')}
                           autoComplete="off"
                           id="account-form--company-name"
                           maxLength="50"
                           className={getInputClassName('company_name')}/>
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--address"
                           className="form__label form__label--required">
                        Add&#8204;ress:
                    </label>
                    {autoSuggestAddress &&
                        <Controller
                            name={autoSuggestInputName}
                            control={control}
                            rules={addressValidationRules}
                            render={({field: { onChange, onBlur, value, },}) =>
                                <FormAddressInputAutoSuggest inputValue={value}
                                                             inputName={'data_input_field_1'}
                                                             onInputChange={onChange}
                                                             onInputBlur={onBlur}
                                                             onSuggestionSelected={onSuggestedAddressSelect} />
                            }
                        />
                        ||
                        <input type="text"
                               {...register('address',addressValidationRules)}
                               id="account-form--address"
                               maxLength="50"
                               className={getInputClassName('address')}/>
                    }
                    {!!errors[autoSuggestInputName] && errors[autoSuggestInputName].type === 'isPoBox' &&
                        <small className="form__error">a shipping address can't be a P.O. Box</small>
                    }
                    {!!errors[autoSuggestInputName] && errors[autoSuggestInputName].type === 'required' &&
                        <small className="form__error">Address is required</small>
                    }
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--address-2">Suite, Apartment, etc. 2:</label>
                    <input type="text"
                           {...register('address2',{ minLength: 2, validate: {
                                   isPoBox: (value)=>{
                                       if(type === 'shipping')
                                           return !validation.isPoBox(value) || 'a shipping address can\'t be a P.O. Box';
                                       else
                                           return true;
                                   },}})
                           }
                           id="account-form--address-2"
                           maxLength="25"
                           className={getInputClassName('address2')}/>
                    {!!errors.address2 && errors.address2.type === 'minLength' &&
                        <small className="form__error">Minimum of two characters</small>
                    }
                    {!!errors.address2 && errors.address2.type === 'isPoBox' &&
                        <small className="form__error">a shipping address can't be a P.O. Box</small>
                    }
                </li>
                <li className="form__input-list-item">
                        <label htmlFor="account-form--city"
                               className="form__label form__label--required">
                            City:
                        </label>
                        <input type="text"
                               {...register('city', {required: true, maxLength: 40,})}
                               id="account-form--city"
                               className={getInputClassName('city')}/>
                    {!!errors.city &&
                        <small className="form__error">
                            City is required
                        </small>
                    }
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--state" className="form__label form__label--required">
                        State:
                    </label>
                    <Controller
                        name="state"
                        control={control}
                        rules={{required: true}}
                        render={({field: { onChange, onBlur, value, },}) =>
                            <FormSelectState name="state"
                                             id="account-form--state"
                                             value={value}
                                             className={getInputClassName('state')}
                                             onChange={onChange}
                                             onBlur={onBlur} />
                        }
                    />
                    {!!errors.state &&
                        <small className="form__error">
                            State is required
                        </small>
                    }
                </li>
                <li className="form__input-list-item">
                    <label htmlFor="account-form--zip5" className="form__label form__label--required">
                        Zip:
                    </label>
                    <Controller
                        name="zip"
                        control={control}
                        rules={{required: true, validate: (value)=>{
                            return !!value.match(/^(\d{5})-?(\d{4})?$/)?.length || 'invalid zip code format';
                        },}}
                        render={({field: { onChange, onBlur, value, },}) =>
                            <Cleave id="account-form--zip5"
                                    name="zip"
                                    value={value}
                                    options={{delimiter: '-',blocks: [5, 4], numericOnly: true, }}
                                    onBlur={onBlur}
                                    onChange={onChange}
                                    className={getInputClassName('zip')} />
                        }
                    />
                    {!!errors.zip &&
                        <small className="form__error">
                            A valid zip code is required
                        </small>
                    }
                </li>
                <li className="form__input-list-item form__input-list-item--flex">
                    <div style={{flex: '1 1 auto', marginRight: '1rem'}}>
                        <label htmlFor="account-form--phone"
                               className="form__label form__label--required">
                            Phone:
                        </label>
                        <AccountAddressFormPhoneInput control={control}
                                                      setValue={setValue}
                                                      inputClassName={getInputClassName('phone')}
                                                      errors={errors} />
                        {!!errors.phone &&
                            <small className="form__error">
                                A valid phone number is required
                            </small>
                        }
                    </div>
                    <div style={{flex: '1 1 auto', maxWidth: '6rem'}}>
                        <label htmlFor="account-form--phone"
                               className="form__label">
                            Phone Ext:
                        </label>
                        <input type="text"
                               {...register('phone_ext')}
                               id="account-form--phone-ext"
                               maxLength="4"
                               className={getInputClassName('phone_ext')}/>
                    </div>
                </li>
                {showAddressLocationType &&
                    <li className="form__input-list-item">
                        <label htmlFor="account-form--location_class"
                               className="form__label form__label--required">
                            Address Type:
                        </label>
                        <select name=""
                                {...register('location_class', {required: true})}
                                id="account-form--location_class"
                                className={getInputClassName('location_class')}>
                            <option value="">-- Address Type --</option>
                            <option value="Business">Business</option>
                            <option value="Residence">Residential</option>
                        </select>
                        {!!errors.location_class &&
                        <small className="form__error">
                            Address type is required
                        </small>
                        }
                    </li>
                }

            </ol>
        </fieldset>
    );
};

export default AccountAddressFormInput;
